import React from 'react'
import NavigationButton_showMore from "./actions/show-more"
import Navigation_ButtonHint from "../components/hint/hint-section";
import Navigation_BaseButton from "./base-button";

type Props = {
    className?          : string,
    inMorePopover?      : boolean
}

// const debug = "Navigation_ButtonHelp"
const debug = false


// this buttons is not generic used in specific layouts !!!

export default class Navigation_ButtonHelp extends React.Component<Props> {

    public refHint                  : React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        debug && console.log(debug, 'showContextMenu', e,)

        NavigationButton_showMore(e, this)
}

    onClick = () => {
        gd.navigation.goTo('app-help')
    }

    render() {

        debug && console.log(debug, 'render()')

        return (
            <Navigation_BaseButton className            = {this.props.className}
                                   icon                 = "i5-nav-support"
                                   inMorePopover        = {this.props.inMorePopover}
                                   onClick              = {this.onClick}
                                   showContextMenu      = {this.showContextMenu}>
                {!this.props.inMorePopover &&
                    <Navigation_ButtonHint ref = {this.refHint} hint="Help" />
                }
            </Navigation_BaseButton>
        )
    }
}
